import { MetricsCollector } from '../../../services/metrics/types';

export function dispatchEditorButtonClick(
  metrics: MetricsCollector,
  eventName: string,
  assetName: string,
  assetType: string,
  attributes?: Record<string, string>,
) {
  const props = {
    AssetType: assetType,
    AssetName: assetName,
    ...attributes,
  };
  metrics.onTrackEvent(eventName, props);
}

export const EditorCommonEvents = {
  LeftHandNavResized: 'Left Hand Navigation Resized',
};

export const EditorCommonAssetEventProperties = {
  AssetType: 'assetType',
  AssetName: 'assetName',
};

export const EditorCommonAssetEvents = {
  // Delete Asset
  DeleteAssetClicked: 'Delete Asset Button Clicked',
  DeleteAssetClickedModalSubmit: 'Delete Asset Modal Submit Button Clicked',
  DeleteAssetClickedModalCancel: 'Delete Asset Modal Cancel Button Clicked',
  DeleteAssetSuccess: 'Asset Deleted',
  // Create Assets
  CreateAssetClicked: 'Create Asset Button Clicked',
  // Save Assets
  SaveAssetClicked: 'Save Asset Button Clicked',
  SaveAssetClickedSubmit: 'Save Asset Modal Submit Button Clicked',
  SaveAssetClickedCancel: 'Save Asset Modal Cancel Button Clicked',
  SaveAssetSuccess: 'Asset Saved',
};

export const EditorAssetEvents = {
  // Options
  ImportOptionsButtonClicked: 'Import Options Button Clicked',
  ImportOptionsModalSubmitButtonClicked: 'Import Options Modal Submit Button Clicked',
  ImportOptionsModalCancelButtonClicked: 'Import Options Modal Cancel Button Clicked',
  OptionsImported: 'Options Imported',
  ExportOptionsButtonClicked: 'Export Options Button Clicked',
  OptionsPaginationButtonClicked: 'Options Pagination Button Clicked',
  OptionsPaginationSizeSelected: 'Options Pagination Size Selected',
  OptionsSearchButtonClicked: 'Options Search Button Clicked',
  OptionsClearSearchButtonClicked: 'Options Clear Search Button Clicked',
};

export const EditorAssetTypes = {
  Bucket: 'bucket',
  EnquiryLine: 'enquiry-line',
  WrapUpLine: 'wrap-up-line',
  RootLine: 'root-enquiry-line',
  Locale: 'locale',
  Question: 'question',
  OptionList: 'option-list',
  PriorEnquiryChannel: 'prior-enquiry-channel',
  Table: 'table',
  UnitTest: 'unit-test',
};
